export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const ACCESS_TOKEN_REFRESHED='ACCESS_TOKEN_REFRESHED'
// export const FETCH_PAST_EXAMS_SUCCESS = 'FETCH_PAST_EXAMS_SUCCESS';
export const FETCH_SCHEDULED_EXAMS_SUCCESS = 'FETCH_SCHEDULED_EXAMS_SUCCESS';
export const FETCH_EXAMS_SUCCESS = 'FETCH_EXAMS_SUCCESS';
export const FETCH_EXAM_DETAILS_SUCCESS = 'FETCH_EXAM_DETAILS_SUCCESS';
export const CREATE_EXAM_SUCCESS = 'CREATE_EXAM_SUCCESS';
export const EDIT_EXAM_SUCCESS = 'EDIT_EXAM_SUCCESS';
